import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultStyleMegaOptions } from "../../../../Constant";
import { MEGA_OPTION_DEFAULT } from "../../../../Data/FormControl/MegaOptions";
import  DefaultStyleForm  from "../DefaultStyle/DefaultStyleForm";
import  CommonCardFooter  from "../Common/CommonCardFooter";

const DefaultStyle = () => {
  return (
    <Col sm="12" xxl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={DefaultStyleMegaOptions} span={MEGA_OPTION_DEFAULT} />
        <CardBody className="megaoptions-border-space-sm">
        <DefaultStyleForm />
        </CardBody>
        <CommonCardFooter footerClass='text-end' color1='primary' color2='light'/>
      </Card>
    </Col>
  );
};

export default DefaultStyle;
